import React, { useState } from "react";
import {
  Box,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from "@mui/material";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button
} from "@mui/material";
import { useEffect } from "react";
import axios from "axios";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import LanguageIcon from "@mui/icons-material/Language";
// import EditSite from "./EditSite";
import "./SiteReports.css";
import { toast, ToastContainer } from "react-toastify";
// import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import apiService from "../../../utils/apiservice";


const API_URL = process.env.REACT_APP_API_DJANGO_URL;

const SiteReports = () => {
  const [rows, setRows] = useState([]);
  const [selectedSiteData, setSelectedSiteData] = useState(null);
  const [editOpen, setEditOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [siteToDelete, setSiteToDelete] = useState(null);
  const [deleteMessage, setDeleteMessage] = useState("");
  const [deleteError, setDeleteError] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState("");

  const [sites, setSites] = useState([]);
  const [selectedSite, setSelectedSite] = useState("");


  // Add these inside your ViewSites component
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);


  const role = localStorage.getItem("role");
  const userId = localStorage.getItem("userId");
  const token = localStorage.getItem("accessToken");
  const customerId = localStorage.getItem("customer_id");


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };



  useEffect(() => {
    fetchCustomers();
  }, [role]);

  useEffect(() => {
    if (selectedCustomer) {
      fetchSites(selectedCustomer);
    }
  }, [selectedCustomer]);


  // const fetchSites = async () => {
  //   try {
  //     const token = localStorage.getItem("accessToken");
  //     const customerId = localStorage.getItem("customer_id");

  //     if (!customerId) return;

  //     // Force GET with empty JSON body
  //     const response = await apiService({
  //       url: `/api/get_customer_sites/${customerId}/`,
  //       method: "GET",
  //       data: {}, // 👈 force empty JSON body for backend
  //     });
  //     const formattedData = response.data.data.map((site, index) => ({
  //       id: index + 1,
  //       site_id: site.site_id,
  //       name: site.name,
  //       survey_no: site.survey_no,
  //       pin_code: site.pin_code,
  //       society_reg_no: site.society_reg_no,
  //       address: site.address,
  //       latitude: site.latitude,
  //       longitude: site.longitude,
  //       asset_id: site.asset_id,
  //     }));

  //     setRows(formattedData);
  //   } catch (error) {
  //     console.error("Error fetching sites:", error);
  //   }
  // };
  const fetchCustomers = async () => {


    // ✅ Customer Admin
    if (role === "CA" || role === "SE") {
      setSelectedCustomer(customerId);
      fetchSites(customerId);
      return;
    }


    try {
      const response = await apiService({
        url: "/api/get_customers/",
        method: "GET",
        data: {},
      });

      const customerData = response?.data?.data || response?.data || [];

      setCustomers(customerData);

      if (customerData.length > 0) {
        const initialId = customerData[0].tb_customer_id;

        setSelectedCustomer(initialId);

        // Load sites of first customer
        fetchSites(initialId);
      }

    } catch (error) {
      console.error("Error fetching customers:", error);
      setCustomers([]);
    }
  };




  const fetchSites = async (customerId) => {
    try {

      // const customerId = localStorage.getItem("customer_id");
      const role = localStorage.getItem("role");
      const userId = localStorage.getItem("userId");

      let formattedData = [];

      // ✅ COMMON CONFIG
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        data: {},
      };

      // =========================================
      // ✅ SUPERVISOR -> ONLY ASSIGNED SITES
      // =========================================
      if (role === "S") {

        const response = await axios.get(
          `${API_URL}/api/supervisor_sites/${userId}/`,
          config
        );

        const sites = response.data.sites || [];

        formattedData = sites.map((site, index) => ({
          id: index + 1,
          site_id: site.site_id,
          name: site.name,
          survey_no: site.survey_no,
          pin_code: site.pin_code,
          society_reg_no: site.society_reg_no,
          address: site.address,
          latitude: site.latitude,
          longitude: site.longitude,
          asset_id: site.asset_id,
        }));
      }

      // =========================================
      // ✅ SITE ENGINEER -> ONLY ASSIGNED SITES
      // =========================================
      else if (role === "SE") {

        const response = await axios.get(
          `${API_URL}/api/engineer_sites/${userId}/`,
          config
        );

        const sites = response.data.sites || [];

        formattedData = sites.map((site, index) => ({
          id: index + 1,
          site_id: site.site_id,
          name: site.site_name,
          survey_no: site.survey_no,
          pin_code: site.pin_code,
          society_reg_no: site.society_reg_no,
          address: site.address,
          latitude: site.latitude,
          longitude: site.longitude,
          asset_id: site.asset_id,
        }));
      }

      // =========================================
      // ✅ SUPER ADMIN / CUSTOMER -> ALL SITES
      // =========================================
      else {

        const response = await apiService({
          url: `/api/get_customer_sites/${customerId}/`,
          method: "GET",
          data: {},
        });

        formattedData = (response.data.data || []).map((site, index) => ({
          id: index + 1,
          site_id: site.site_id,
          name: site.name,
          survey_no: site.survey_no,
          pin_code: site.pin_code,
          society_reg_no: site.society_reg_no,
          address: site.address,
          latitude: site.latitude,
          longitude: site.longitude,
          asset_id: site.asset_id,
        }));
      }

      setRows(formattedData);

    } catch (error) {

      console.error("Error fetching sites:", error);
      setRows([]);
    }
  };

  const handleEditClick = (site) => {
    setSelectedSiteData(site);
    setEditOpen(true);
  };

  const handleCloseEdit = () => setEditOpen(false);

  const handleSaveEdit = (updatedSite) => {
    setRows(rows.map(r => r.id === updatedSite.id ? updatedSite : r));
    setEditOpen(false);
  };


  const handleDeleteClick = (site) => {
    setSiteToDelete(site);
    setDeleteOpen(true);
  };


  const handleCancelDelete = () => {
    setDeleteOpen(false);
    setDeleteMessage("");
    setDeleteError(false);
  };

  const handleConfirmDelete = async () => {
    if (!siteToDelete) return;

    try {
      const token = localStorage.getItem("accessToken");
      const assetId = siteToDelete.asset_id;

      const response = await apiService({
        url: `/api/delete_site/${assetId}/`,
        method: "DELETE",
        data: {}, // force empty JSON body for backend
      });
      // ✅ Success
      const msg = response.data.message || "Site deleted successfully!";
      setDeleteMessage(msg);
      setDeleteError(false);

      toast.success(msg);

      // Remove row after short delay (optional UX)
      setTimeout(() => {
        setRows(rows.filter(r => r.id !== siteToDelete.id));
        setDeleteOpen(false);
        setDeleteMessage("");
      }, 1500);

    } catch (error) {
      console.error("Error deleting site:", error);

      const backendMessage =
        error.response?.data?.error ||
        error.response?.data?.message ||
        "Failed to delete site.";

      // ❌ Show inside modal
      setDeleteMessage(backendMessage);
      setDeleteError(true);

      // toast.error(backendMessage);
    }
  };

  // const handleCancelDelete = () => {
  //   setDeleteOpen(false);
  // };
  const selectedCustomerName =
    customers.find(
      (c) => c.tb_customer_id === selectedCustomer
    )?.customer_name || "Customer";

  // 🔹 CSV Export
  const handleExportCSV = () => {
    const headers = [
      "Sr No",
      "Site Name",
      "Survey No",
      "Pin Code",
      "Society Reg No",
      "Address",
    ];

    const csvRows = rows.map((row, index) => [
      index + 1,
      row.name,
      row.survey_no,
      row.pin_code,
      row.society_reg_no,
      row.address,
    ]);

    const csvContent = [
      // [`Customer Name:,${selectedCustomerName}`],
      ...(role !== "CA" && role !== "SE"
        ? [[`Customer Name:,${selectedCustomerName}`]]
        : []),

      [],
      headers,
      ...csvRows,
    ]
      .map((e) => e.join(","))
      .join("\n");

    const csv = "data:text/csv;charset=utf-8," + csvContent;

    const link = document.createElement("a");
    link.href = encodeURI(csv);

    // File Name
    // link.download = `${selectedCustomerName}_Site_Report.csv`;
    link.download =
      role !== "CA" && role !== "SE"
        ? `${selectedCustomerName}_Site_Report.csv`
        : `Site_Report.csv`;

    link.click();
  };

  // 🔹 PDF Export
  const handleExportPDF = () => {
    const doc = new jsPDF();

    doc.setFontSize(16);
    doc.text("Site Report", 14, 15);

    // Customer Name
    // doc.setFontSize(12);
    // doc.text(`Customer Name: ${selectedCustomerName}`, 14, 25);

    // autoTable(doc, {
    //   startY: 35,


    doc.setFontSize(12);

    let y = 25;

    if (role !== "CA" && role !== "SE") {
      doc.text(`Customer Name: ${selectedCustomerName}`, 14, y);
      y += 10;
    }

    autoTable(doc, {
      startY: y,
      head: [[
        "Sr No",
        "Site Name",
        "Survey No",
        "Pin Code",
        "Society Reg No",
        "Address",
      ]],
      body: rows.map((row, index) => [
        index + 1,
        row.name,
        row.survey_no,
        row.pin_code,
        row.society_reg_no,
        row.address,
      ]),
    });

    // File Name
    // doc.save(`${selectedCustomerName}_Site_Report.pdf`);
    doc.save(
      role !== "CA" && role !== "SE"
        ? `${selectedCustomerName}_Site_Report.pdf`
        : `Site_Report.pdf`
    );
  };



  return (
    <Box className="view-sites-container">

      {/* ✅ Toast Container */}
      <ToastContainer position="top-right" autoClose={3000} />

      {/* <TableContainer component={Paper} className="site-table"></TableContainer> */}
      <Box className="top-bar">

        {role !== "CA" && role !== "SE" && (
          <FormControl sx={{ width: 300 }}>
            <InputLabel>Select Customer</InputLabel>

            <Select
              value={selectedCustomer}
              label="Select Customer"
              onChange={(e) => {
                setSelectedCustomer(e.target.value);
              }}
            >
              {customers.map((customer) => (
                <MenuItem
                  key={customer.tb_customer_id}
                  value={customer.tb_customer_id}
                >
                  {customer.customer_name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}

        <Box className="export-buttons">
          <Button onClick={handleExportCSV} className="btn-csv">
            CSV
          </Button>

          <Button onClick={handleExportPDF} className="btn-pdf">
            PDF
          </Button>
        </Box>
      </Box>
      <TableContainer component={Paper} className="site-table">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Sr No</TableCell>
              <TableCell>Site Name</TableCell>
              <TableCell>Survey No</TableCell>
              <TableCell>Pin Code</TableCell>
              <TableCell>Society Reg No</TableCell>
              <TableCell>Address</TableCell>
              {/* <TableCell align="center">Actions</TableCell> */}
            </TableRow>
          </TableHead>

          <TableBody>
            {rows.length === 0 ? (
              <TableRow>
                <TableCell colSpan={7} align="center">
                  No Sites Are Available
                </TableCell>
              </TableRow>
            ) : (
              rows
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => (
                  <TableRow key={row.id}>
                    <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                    <TableCell>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        {row.name}
                      </Box>
                    </TableCell>
                    <TableCell>{row.survey_no}</TableCell>
                    <TableCell>{row.pin_code}</TableCell>
                    <TableCell>{row.society_reg_no}</TableCell>
                    <TableCell>{row.address}</TableCell>
                    {/* <TableCell align="center">
            <IconButton color="primary" onClick={() => handleEditClick(row)}>
              <EditIcon />
            </IconButton>
            <IconButton color="error" onClick={() => handleDeleteClick(row)}>
              <DeleteIcon />
            </IconButton>
          </TableCell> */}
                  </TableRow>
                ))
            )}
          </TableBody>
        </Table>


      </TableContainer>

      <div className="pagination-bar">
        <div className="rows-select">
          Rows per page:
          <select value={rowsPerPage} onChange={handleChangeRowsPerPage}>
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={25}>25</option>
          </select>
        </div>
        <div className="page-info">
          {rows.length > 0 ? page * rowsPerPage + 1 : 0}-
          {Math.min((page + 1) * rowsPerPage, rows.length)} of {rows.length}
        </div>
        <div className="page-arrows">
          <button disabled={page === 0} onClick={() => setPage(page - 1)}>‹</button>
          <button disabled={(page + 1) * rowsPerPage >= rows.length} onClick={() => setPage(page + 1)}>›</button>
        </div>
      </div>

      {/* {selectedSite && (
        <EditSite
          open={editOpen}
          onClose={handleCloseEdit}
          site={selectedSite}
          onSave={handleSaveEdit}
        />
      )} */}

      <Dialog
        open={deleteOpen}
        onClose={handleCancelDelete}
        className="delete-dialog"
      >
        <DialogTitle className="delete-dialog-title">
          Delete Site
        </DialogTitle>

        <DialogContent>
          <DialogContentText className="delete-dialog-text">
            {!deleteMessage &&
              "Are you sure to delete this site?"}
          </DialogContentText>

          {/* ✅ Backend Message */}
          {deleteMessage && (
            <Box
              sx={{
                mt: 2,
                p: 2,
                borderRadius: 2,
                backgroundColor: deleteError ? "#fdecea" : "#e8f5e9",
                color: deleteError ? "#d32f2f" : "#2e7d32",
                fontWeight: 500,
              }}
            >
              {deleteMessage}
            </Box>
          )}
        </DialogContent>

        <DialogActions className="delete-dialog-actions">

          {/* ❌ If error → show only OK */}
          {deleteError && deleteMessage ? (
            <Button
              onClick={handleCancelDelete}
              variant="contained"
              color="primary"
            >
              OK
            </Button>
          ) : deleteMessage && !deleteError ? (
            /* ✅ If success → show Done */
            <Button
              onClick={handleCancelDelete}
              variant="contained"
              color="success"
            >
              Done
            </Button>
          ) : (
            /* 🟢 Default → show Cancel + Delete */
            <>
              <Button
                onClick={handleCancelDelete}
                variant="outlined"
                className="delete-cancel-btn"
              >
                Cancel
              </Button>

              <Button
                onClick={handleConfirmDelete}
                variant="contained"
                color="error"
              >
                Delete
              </Button>
            </>
          )}

        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default SiteReports;